module.exports = __webpack_public_path__ + "static/media/SchneegrenzeFull.3f4f16bc.svg";